import type { UserStatus } from '@/domain/users/entities/user.entity'

interface UserStatusBadgeProps {
  status: UserStatus
  className?: string
}

export function UserStatusBadge({ status, className = '' }: UserStatusBadgeProps) {
  const isActive = status === 'active'
  const label = status.charAt(0).toUpperCase() + status.slice(1)

  return (
    <span
      className={`inline-flex px-2 py-1 text-xs font-semibold rounded ${
        isActive ? 'bg-teal-100 text-teal-800' : 'bg-gray-100 text-gray-800'
      } ${className}`}
      style={isActive ? { backgroundColor: '#019b9a', color: '#ffffff' } : undefined}
    >
      {label}
    </span>
  )
}
